interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function getPages(page: number, totalPages: number): (number | '...')[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  const pages: (number | '...')[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) pages.push('...');
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < totalPages - 1) pages.push('...');
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" />
        <span className="hidden sm:inline">上一页</span>
      </button>

      {getPages(page, totalPages).map((p, idx) =>
        p === '...' ? (
          <span key={`ellipsis-${idx}`} className="px-1 text-foreground-400">
            ...
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`flex h-9 w-9 items-center justify-center rounded-md text-sm font-medium transition ${
              p === page
                ? 'bg-primary-500 text-background-50'
                : 'border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
            }`}
          >
            {p}
          </button>
        )
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <span className="hidden sm:inline">下一页</span>
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}